import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import * as _ from 'lodash';

import { TaxGroupSetupFieldEnum as Fields } from 'Common/FieldEnum';

import { InputField } from 'Common/SemanticWrapper';
import { Form } from 'semantic-ui-react';
import { StyledReduxFormError } from 'Components';
import { InputMode } from 'Common/FormEnum';

class TaxGroupSetupForm extends Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.valid !== this.props.valid) {
      this.props.setIsValid(nextProps.valid);
    }
  }

  render() {
    const { handleSubmit, error } = this.props;

    return (
      <div>
        <Form onSubmit={handleSubmit}>
          <Field name={Fields.Id} component="input" type="hidden" />
          <Field name={Fields.ReferenceId} component="input" type="hidden" />
          <Field
            name={Fields.Description}
            component={InputField}
            type="text"
            maxLength={30}
            autoFocus={true}
            label={'Description'}
          />
          <Field
            label={'State'}
            name={Fields.State}
            component={InputField}
            type="text"
            className="input--full"
            mode={InputMode.Decimal}
            numericSize={[8, 2]}
            maxLength={6}
          />
          <Field
            name={Fields.County}
            component={InputField}
            type="text"
            label={'County'}
            className="input--full"
            mode={InputMode.Decimal}
            numericSize={[8, 2]}
            maxLength={6}
          />
          <Field
            name={Fields.Local}
            component={InputField}
            type="text"
            label={'Local'}
            className="input--full"
            mode={InputMode.Decimal}
            numericSize={[8, 2]}
            maxLength={6}
          />
          <StyledReduxFormError error={error} />
        </Form>
      </div>
    );
  }
}

const validate = values => {
  const errors = {};

  if (values[Fields.State] > 999) {
    errors[Fields.State] = 'Entry must be a numeric value less than 1000';
  }
  if (values[Fields.County] > 999) {
    errors[Fields.County] = 'Entry must be a numeric value less than 1000';
  }
  if (values[Fields.Local] > 999) {
    errors[Fields.Local] = ' Entry must be a numeric value less than 1000';
  }

  if (
    !values[Fields.Description] ||
    _.trim(values[Fields.Description]).length === 0
  ) {
    errors[Fields.Description] = 'Description is required';
  }
  return errors;
};

export default reduxForm({
  validate,
  form: 'TaxGroupSetupForm',
})(TaxGroupSetupForm);



// WEBPACK FOOTER //
// ./src/pages/inventory/taxgroupsetup/components/TaxGroupSetupForm.js